// extracted by mini-css-extract-plugin
module.exports = {"wave_box":"ParkRoad_wave_box__K8OKL","wave_box_title":"ParkRoad_wave_box_title__Z8xBH","wave_item":"ParkRoad_wave_item__1Z2iU","wave_item_label":"ParkRoad_wave_item_label__2tHRb"};